// extracted by mini-css-extract-plugin
export default {"skillCard":"your-career-skills_skillCard__XgZH9","skillCardText":"your-career-skills_skillCardText__Aqryh"};